import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown,faSearch } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../Loader/Loader';
import Pagination, { usePagination } from '../Components/Pagination';
import Search from '../Components/Search';
import { decryptData } from '../../utils/storageCrypto';
import { BuildingOffice2Icon  } from '@heroicons/react/24/outline';



const HubList = () => {
  const [hubs, setHubs] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const RETRY_LIMIT = 3;
  const [retryCount, setRetryCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const searchTypes = ["Hub Number", "Hub Name", "Company Name", "Mobile Number", "Zone"];
const [filteredHubs, setFilteredHubs] = useState([]);

  const [persistedSearchQuery, setPersistedSearchQuery] = useState("");
const [persistedSearchType, setPersistedSearchType] = useState("");
const [searchChips, setSearchChips] = useState(() => {
  const saved = sessionStorage.getItem('hubSearchChips');
  return saved ? JSON.parse(saved) : [];
});
 const hubsToDisplay =
  filteredHubs.length > 0 || persistedSearchQuery
    ? filteredHubs
    : hubs;

  const {
  currentItems,
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  handlePageChange,
  handlePreviousPage,
  handleNextPage,
  resetToFirstPage
} = usePagination(hubsToDisplay, 10);

useEffect(() => {
  sessionStorage.setItem('hubSearchChips', JSON.stringify(searchChips));
}, [searchChips]);

useEffect(() => {
  if (hubs.length > 0) {
    if (persistedSearchQuery && persistedSearchType) {
      handleSearch(persistedSearchQuery, persistedSearchType);
    } else {
      setFilteredHubs(hubs);
    }
  }
}, [hubs]);

useEffect(() => {
      if (persistedSearchQuery && persistedSearchType) {
        const newChip = [{
          query: persistedSearchQuery,
          type: persistedSearchType
        }];
    
        setSearchChips(newChip);
        sessionStorage.setItem('hubSearchChips', JSON.stringify(newChip));
      }
    }, [persistedSearchQuery, persistedSearchType]);


  const handleSearch = (query, type) => {
 if (!query || query.trim() === '') {
    setFilteredHubs(hubs);
     setSearchChips([]);
  sessionStorage.removeItem('hubSearchChips');
    resetToFirstPage();
    return;
  }

  const lower = (query || "").toLowerCase();

  const filtered = hubs.filter((hub) => {
    switch (type) {
      case "Hub Number":
        return hub.hub_number?.toString().toLowerCase().includes(lower);

      case "Hub Name":
        return hub.hub_name?.toLowerCase().includes(lower);

      case "Company Name":
        return hub.company_name?.toLowerCase().includes(lower);

      case "Mobile Number":
        return hub.mobile_number?.toString().includes(lower);

      case "Zone":
        return hub.zoneId?.zone_name?.toLowerCase().includes(lower);

      default:
        return true;
    }
  });

  setFilteredHubs(filtered);
  resetToFirstPage();
};

useEffect(() => {
  const savedSearchChips = JSON.parse(sessionStorage.getItem('hubSearchChips')) || [];
  setSearchChips(savedSearchChips);

  if (savedSearchChips.length > 0) {
    const lastChip = savedSearchChips[0];
    setPersistedSearchQuery(lastChip.query);
    setPersistedSearchType(lastChip.type);
  }

  fetchHubs();
}, []);

const handleRemoveSearchChip = () => {
  setSearchChips([]);
  sessionStorage.removeItem('hubSearchChips');

  setPersistedSearchQuery('');
  setPersistedSearchType('');
  setFilteredHubs(hubs);
};



const handleAddSearchChip = (query, type) => {
  if (!type) return;

  const actualQuery = query.trim();

  const newChip = [{ query: actualQuery, type }]; // only one chip

  setSearchChips(newChip);
  sessionStorage.setItem('hubSearchChips', JSON.stringify(newChip));

  setPersistedSearchQuery(actualQuery);
  setPersistedSearchType(type);

  handleSearch(actualQuery, type);
};

const handleChipClick = (chip) => {
  setPersistedSearchType(chip.type);
  setPersistedSearchQuery(chip.query);
  handleSearch(chip.query, chip.type);
};


  const sortArray = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  
    const getNestedValue = (item, key) => {
      return key.split('.').reduce((value, keyPart) => {
        return value ? value[keyPart] : undefined;
      }, item);
    };
  
    const sortedArray = [...hubs].sort((a, b) => {
      const aValue = getNestedValue(a, key);
      const bValue = getNestedValue(b, key);
  
      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return direction === 'ascending' ? aValue - bValue : bValue - aValue;
      } else {
        const aString = aValue.toString().toLowerCase();
        const bString = bValue.toString().toLowerCase();
        return direction === 'ascending'
          ? aString.localeCompare(bString)
          : bString.localeCompare(aString);
      }
    });
  
    setHubs(sortedArray);
     resetToFirstPage();
  };
  
  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? faSortUp : faSortDown;
    }
    return null;
  };

  useEffect(() => {
    fetchHubs();
  }, []);

  const fetchHubs = async (attempt = 0) => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);

      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}hub/get-all-hubs`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      });

      const data = await response.json();
      console.log(data.data);
      if (response.ok) {
        setHubs(data.data || []);
      } else {
        console.error(data.message);
      }

      if (response.status === 500) {
        // Handle retry logic here if needed
      }
    } catch (error) {
      console.error('Failed to fetch hubs:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1);
        setTimeout(() => fetchHubs(attempt + 1), 1000);
      } else {
        setIsLoading(false);
        console.error('Internal Server Error. Kindly Retry.'); // Handle error without popup
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreate = () => {
    navigate("/admin/app/settings/newhub");
  };
  const handleNavigateToHubDetails = (hub) => {
    navigate("/admin/app/settings/hubdetails", {state:{hubData:hub}});
    console.log(hub);
  }


  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="bg-white flex flex-row w-full justify-left h-full overflow-y-hidden">
      <div className="flex flex-row w-full">
        <div className="w-full flex-1">
          <div className="flex flex-col w-full h-full justify-center items-center">
            <div className="w-full h-full flex flex-col justify-between">
              <div className="w-full h-16 border-b flex items-center">
                <div className="flex w-full justify-between px-4 mt-4 mb-4 items-center">
                  <div className='space-x-10 flex flex-row'>
                    <h1 className="text-lg font-bold whitespace-nowrap">Hubs List</h1>
                    {hubs && hubs.length > 0 && (
                      <>
                   <Search
  searchQuery={persistedSearchQuery}
  setSearchQuery={setPersistedSearchQuery}
  searchType={persistedSearchType}
  setSearchType={setPersistedSearchType}
  searchTypes={searchTypes}
  onSearch={handleSearch}
  onSearchSubmit={handleAddSearchChip}
  placeholder="Search hubs..."
/> 
 

<div className="flex flex-row items-center gap-3  whitespace-nowrap">
  {searchChips.map((chip, index) => {
 const isActive = chip.type === persistedSearchType;

      const chipClasses = `flex items-center max-w-xs text-sm px-3 py-1 rounded-full shadow-sm transition-all duration-150 ${
        isActive
          ? 'bg-red-500 text-white'
          : 'bg-gray-100 text-gray-800'
      }`;

    return (
      <div
         key={`${chip.type}-${chip.query}-${index}`} // Better unique key
      className={chipClasses}
      style={{ whiteSpace: 'nowrap' }}
      onClick={() => handleChipClick(chip)}
    >
      <span className="whitespace-nowrap ">
        {chip.type}: {chip.query}
      </span>

        <button
          className="ml-2 font-bold"
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveSearchChip(chip);
          }}
        >
          ×
        </button>
      </div>
    );
  })}
</div>

</>
)}


                  </div>
                  <button onClick={handleCreate} className="bg-[#F7525A] text-white z-20 px-2 py-1 rounded"
                    title="" data-tooltip="Create Hub" style={{ '--tooltip-bg': 'black' }}>+ New</button>
                </div>
              </div>


                <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                showInfo={true}
                hideControls={true} 
                itemName="hubs"
              />


              <div className="w-full h-full bg-white rounded-xs overflow-hidden">
                <div className="overflow-y-auto h-[80vh]">
                  {hubs && Array.isArray(hubs) && hubs.length > 0 ? (
                    <table className="w-full mb-5">
                      <thead className="sticky top-0 z-10 bg-[#fafafc] text-[#6c7184] border-b">
                        <tr className='border-b'>
                          <th className="text-xs py-3 text-center">
                            <input type="checkbox" className="mr-2" />
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('hub_name')}>
                            Hub ID {getSortIcon('hub_number') && <FontAwesomeIcon icon={getSortIcon('hub_name')} />}
                          </th>
                         
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('hub_name')}>
                            Hub Name {getSortIcon('hub_name') && <FontAwesomeIcon icon={getSortIcon('hub_name')} />}
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('company_name')}>
                            Company Name {getSortIcon('company_name') && <FontAwesomeIcon icon={getSortIcon('company_name')} />}
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('email')}>
                            Email {getSortIcon('email') && <FontAwesomeIcon icon={getSortIcon('email')} />}
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('mobile_number')}>
                            Mobile Number {getSortIcon('mobile_number') && <FontAwesomeIcon icon={getSortIcon('mobile_number')} />}
                          </th>
                          {/* <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('gst')}>
                            GST {getSortIcon('gst') && <FontAwesomeIcon icon={getSortIcon('gst')} />}
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('pan')}>
                            PAN {getSortIcon('pan') && <FontAwesomeIcon icon={getSortIcon('pan')} />}
                          </th> */}
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('address1')}>
                            Address {getSortIcon('address1') && <FontAwesomeIcon icon={getSortIcon('address1')} />}
                          </th>
                          {/* <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('city')}>
                            City {getSortIcon('city') && <FontAwesomeIcon icon={getSortIcon('city')} />}
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('pincode')}>
                            Pincode {getSortIcon('pincode') && <FontAwesomeIcon icon={getSortIcon('pincode')} />}
                          </th> */}
                           <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('state')}>
                            State {getSortIcon('state') && <FontAwesomeIcon icon={getSortIcon('state')} />}
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('zone_name')}>
                            Zone {getSortIcon('zone_name') && <FontAwesomeIcon icon={getSortIcon('zone_name')} />}
                          </th>
                        </tr> 
                      </thead>
                      <tbody className='border-b border-t'>
                       {currentItems.map((hub) => (
                          <tr key={hub._id} className="text-sm border-b">
                            <td className="py-2 text-center">
                              <input type="checkbox" className="mr-2" />
                            </td>
                            <td className="py-2 text-center text-[#408dfb] font-500 cursor-pointer" onClick={()=>handleNavigateToHubDetails(hub)}>{hub.hub_number}</td>
                            <td className="py-2 text-center" >{hub.hub_name}</td>
                            <td className="py-2 text-center">{hub.company_name}</td>
                            <td className="py-2 text-center">{hub.email}</td>
                            <td className="py-2 text-center">{hub.mobile_number}</td>
                            {/* <td className="py-2 text-center">{hub.gst}</td>
                            <td className="py-2 text-center">{hub.pan}</td> */}
                            <td className="py-2 text-center">{hub.address1}</td>
                            {/* <td className="py-2 text-center">{hub.city}</td>
                            <td className="py-2 text-center">{hub.pincode}</td>*/}
                            <td className="py-2 text-center">{hub.state}</td> 
                            <td className="py-2 text-center">{hub.zoneId?.zone_name || 'N/A'}</td>
                            <td className="py-2 text-center">
                              {/* Removed handleNavigateToQuoteDetails usage */}
                            </td>
                          </tr>
                        ))}
                       {currentItems.length === 0 && (
                          <tr>
                            <td colSpan="8" className="text-center text-[#6c7184] py-4">
                                                    <div className="flex flex-col items-center">
                                                        <FontAwesomeIcon icon={faSearch} className="text-4xl text-gray-300 mb-4" />
                                                        <p className="text-lg font-medium mb-2">No Results Found.</p>
                                                        <p className="text-sm">Try adjusting your search criteria.</p>
                                                    </div>
                                                </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  ) : (
                     <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-8 mx-4 mt-4">
                            <div className="text-center text-gray-500">
                              <div className="mb-4">
                                <BuildingOffice2Icon  className="mx-auto h-12 w-12 text-gray-300" />
                              </div>
                              <h3 className="text-lg font-medium mb-2">No Hubs Found</h3>
                              <p className="text-sm">Hubs will appear once they are created.</p>
                            </div>
                             <div className="flex justify-center items-center mt-4">
                                  <button className="bg-[#F7525A] text-white px-2 py-1 rounded-md" onClick={handleCreate}>Create</button>
                                </div>
                          </div>
                  )}
                </div>
              </div>

                             <div className="sticky bottom-0 bg-white shadow-md z-10 px-4 py-2">

                 <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
                onPreviousPage={handlePreviousPage}
                onNextPage={handleNextPage}
                showInfo={false}
                itemName="hubs"
              />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubList;
